export enum InvitationCollectionActionTaken {
  REGISTERED = 'REGISTERED',
  PENDING = 'PENDING',
  DECLINED = 'DECLINED',
  UNREACHABLE = 'UNREACHABLE',
  NEEDS_ATTENTION = 'NEED_ATTENTION'
}
